import Actions from '../../odata/actions';

const actions = new Actions('shareOfVoiceRecommendation', 'shareOfVoiceRecommendations');

export default actions;
